import { ReportMeta, SeriesPoint, CategoryBar, MoneyBasis } from 'modules/arena/reports/model/types';
import { ReportsController } from 'modules/arena/reports/hooks/useReportsController';
import { formatMoney } from 'modules/arena/reports/model/format';

export interface AreaProps<TBody> {
  body: TBody;
  meta: ReportMeta;
  controller: ReportsController;
}

// Os gráficos trabalham em reais; os dados chegam em centavos. Conversão só para desenhar.
export const toReais = (points: SeriesPoint[]): SeriesPoint[] => points.map((point) => ({ ...point, value: point.value / 100 }));
export const barsToReais = (bars: CategoryBar[]) => bars.map((bar) => ({ ...bar, value: bar.value / 100 }));
export const formatReais = (value: number) => formatMoney(Math.round(value * 100));

export const BASIS_TITLE: Record<MoneyBasis, string> = {
  bruto: 'Recebimento bruto',
  liquido: 'Valor líquido da arena',
};

export const GROUPING_LABEL = { dia: 'por dia', semana: 'por semana', mes: 'por mês' };
